<template>
  <div class="panel granary-panel">
    <div class="type-box">
      <div
        class="pro-item"
        v-for="(it, i) in proType"
        :key="i"
        @click="changeProType(it.code)"
        :class="{ proActive: proActive === it.code }"
      >
        {{ it.name }}
      </div>
    </div>
    <div class="chart-box">
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/nzwData";
import { findQueryList } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["播种面积", "产量"],
      active: 0,
      // proType: ["农作物", "水果", "经济作物"],
      proType: [
        {
          name: "农作物",
          code: "ncp_detail"
        },
        {
          name: "水果",
          code: "sg_detail"
        },
        {
          name: "经济作物",
          code: "jjzw_detail"
        }
      ],
      proActive: "",
      nzwList: [],
      sgList: [],
      jjzwList: [],
      nzwTotalArea: 0,
      nzwTotalCl: 0,
      sgTotalArea: 0,
      sgTotalCl: 0,
      jjzwTotalArea: 0,
      jjzwTotalCl: 0,
      areaUnit: "",
      clUnit: ""
    };
  },
  mounted() {
    this.getData();
    this.startTimer();
    this.loadData();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    changeProType(code, clearT = true) {
      this.proActive = code;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    loadData() {
      // 农作物
      findQueryList({ code: "ncp_detail" }).then(res => {
        this.nzwList = res.data;
        const data = res.data;
        let nTotleArea = 0;
        let nTotleCl = 0;
        data.map(item => {
          nTotleArea += Number(item.area);
          nTotleCl += Number(item.cl);
        });
        res.item.map(it => {
          if (it.code === "area") this.areaUnit = it.unit;
          if (it.code === "cl") this.clUnit = it.unit;
        });

        this.nzwTotalArea = nTotleArea;
        this.nzwTotalCl = nTotleCl;
        // 水果
        findQueryList({ code: "sg_detail" }).then(res => {
          this.sgList = res.data;
          const data = res.data;
          let sTotleArea = 0;
          let sTotleCl = 0;
          data.map(item => {
            sTotleArea += Number(item.area);
            sTotleCl += Number(item.cl);
          });
          this.sgTotalArea = sTotleArea;
          this.sgTotalCl = sTotleCl;
          // 经济作物
          findQueryList({ code: "jjzw_detail" }).then(res => {
            this.jjzwList = res.data;
            const data = res.data;
            let jTotleArea = 0;
            let jTotleCl = 0;
            data.map(item => {
              jTotleArea += Number(item.area);
              jTotleCl += Number(item.cl);
            });
            this.jjzwTotalArea = jTotleArea;
            this.jjzwTotalCl = jTotleCl;
            this.getData();
          });
        });
      });
    },
    getData() {
      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 6;
      let circleData = [];
      let chartTxt = "";
      let chartUnit = "";
      this.chart = this.$echarts.init(this.$refs.chart);
      if (this.proActive === "") {
        if (this.active === 0) {
          // 各作物类型占比
          circleData = [
            {
              name: "农作物",
              value: this.nzwTotalArea
            },
            {
              name: "水果",
              value: this.sgTotalArea
            },
            {
              name: "经济作物",
              value: this.jjzwTotalArea
            }
          ];
          chartTxt = "面积占比";
          chartUnit = this.areaUnit;
        } else {
          circleData = [
            {
              name: "农作物",
              value: this.nzwTotalCl
            },
            {
              name: "水果",
              value: this.sgTotalCl
            },
            {
              name: "经济作物",
              value: this.jjzwTotalCl
            }
          ];
          chartTxt = "产量占比";
          chartUnit = this.clUnit;
        }
        loadChart(
          this.chart,
          circleData,
          fontSizes,
          widths,
          itemGaps,
          "center",
          chartTxt,
          chartUnit
        );
      } else {
        if (this.proActive == "ncp_detail") {
          circleData = this.nzwList;
        } else if (this.proActive == "sg_detail") {
          circleData = this.sgList;
        } else if (this.proActive == "jjzw_detail") {
          circleData = this.jjzwList;
        }
        if (this.active === 0) {
          circleData.map(item => {
            item.value = Number(item.area);
          });
          chartUnit = this.areaUnit;
          chartTxt = "面积占比";
        } else {
          circleData.map(item => {
            item.value = Number(item.cl);
          });
          chartTxt = "产量占比";
          chartUnit = this.clUnit;
        }
        loadChart(
          this.chart,
          circleData,
          fontSizes,
          widths,
          itemGaps,
          "center",
          chartTxt,
          chartUnit
        );
      }
    },
    getData_1() {
      this.chart = this.$echarts.init(this.$refs.chart);
      if (this.active === 0) {
        const sData = [
          {
            name: "谷物",
            value: 3306463,
            children: [
              {
                name: "稻谷",
                value: 3097164
              },
              {
                name: "小麦",
                value: 1651
              },
              {
                name: "玉米",
                value: 206195
              },
              {
                name: "其他",
                value: 1453
              }
            ]
          },
          {
            name: "豆类",
            value: 50461,
            children: [
              {
                name: "豆类",
                value: 50461
              }
            ]
          },
          {
            name: "薯类",
            value: 348459,
            children: [
              {
                name: "番薯",
                value: 246811
              },
              {
                name: "马铃薯",
                value: 101648
              }
            ]
          }
        ];
        //内圈数据
        let innerData = [];
        innerData = sData.map(ele => {
          return {
            name: ele.name,
            value: ele.value
          };
        });

        //外圈数据
        let outerData = [];
        sData.forEach(ele => {
          ele.children.forEach(item => {
            outerData.push(item);
          });
        });
        const name = this.typeList[this.active];
        const unit = "亩";
        loadChart(this.chart, innerData, outerData, name, unit);
      } else {
        const sData = [
          {
            name: "谷物",
            value: 1390793,
            children: [
              {
                name: "稻谷",
                value: 1320892
              },
              {
                name: "小麦",
                value: 499
              },
              {
                name: "玉米",
                value: 69223
              },
              {
                name: "其他",
                value: 179
              }
            ]
          },
          {
            name: "豆类",
            value: 9553,
            children: [
              {
                name: "豆类",
                value: 9553
              }
            ]
          },
          {
            name: "薯类",
            value: 506200,
            children: [
              {
                name: "番薯",
                value: 328690
              },
              {
                name: "马铃薯",
                value: 177510
              }
            ]
          }
          // {
          //   name: "经济作物",
          //   value: 1062404,
          //   children: [
          //     {
          //       name: "甘蔗",
          //       value: 521026
          //     },
          //     {
          //       name: "油料",
          //       value: 149349
          //     },
          //     {
          //       name: "烟叶",
          //       value: 2491
          //     },
          //     {
          //       name: "木薯",
          //       value: 99891
          //     }
          //     // {
          //     //   name: "药材",
          //     //   value: 171926
          //     // }
          //   ]
          // },
          // {
          //   name: "其他作物",
          //   value: 1819503,
          //   children: [
          //     {
          //       name: "蔬菜",
          //       value: 3363800
          //     },
          //     {
          //       name: "瓜类",
          //       value: 13544
          //     },
          //     {
          //       name: "青饲料",
          //       value: 34220
          //     }
          //   ]
          // }
        ];
        //内圈数据
        let innerData = [];
        innerData = sData.map(ele => {
          return {
            name: ele.name,
            value: ele.value
          };
        });

        //外圈数据
        let outerData = [];
        sData.forEach(ele => {
          ele.children.forEach(item => {
            outerData.push(item);
          });
        });
        const name = this.typeList[this.active];
        const unit = "吨";
        loadChart(this.chart, innerData, outerData, name, unit);
      }

      window.addEventListener("resize", () => {
        setTimeout(() => {
          this.chart.resize();
        }, 300);
      });
      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };

      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  .chart-box
    width 100%
    height calc(100% - 40px)
    position relative
    .tab-box
      position absolute
      top 10px
      right 2%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff
  .type-box
    width 100%
    height 30px
    display flex
    align-items center
    padding-left 20px
    margin-top 6px
    font-size 14px
    box-sizing border-box
    color #00ffff
    // background-color #21446e
    .pro-item
      padding 0 4px
      margin-right 30px
      cursor pointer
    .proActive
      color #ffd400
      border-bottom 2px solid #ffd400
</style>
